var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-main-section bgcolor-e4e9ef col-12 float-l" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "chat-internal-main" }, [
          _c("div", { staticClass: "internal-page-banner" }, [
            _c("div", { staticClass: "container" }, [
              _c("h1", [_vm._v("Privacy Policy")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "chat-back-btn",
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function($event) {
                      return _vm.backLogin()
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-angle-double-left back-btn-icon"
                  }),
                  _vm._v(" Back ")
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "internal-page-container" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "vvg-internal-page" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v("Velocity Vehicle Group and its affiliates ("),
                    _c("a", [_vm._v("“VELOCITY”")]),
                    _vm._v(" or "),
                    _c("a", [_vm._v("“VVG”")]),
                    _vm._v(" or"),
                    _c("a", [_vm._v("“we”")]),
                    _vm._v(" or "),
                    _c("a", [_vm._v("“us”")]),
                    _vm._v(") have created this privacy policy (this "),
                    _c("a", [_vm._v('"Privacy Policy"')]),
                    _vm._v(
                      ") in order to demonstrate its commitment to user, visitor, subscriber, and customer privacy with regard to the VELOCITY website located at https://www.velocityvehiclegroup.com/ and any affiliated websites (together, collectively the "
                    ),
                    _c("a", [_vm._v('"Website"')]),
                    _vm._v(
                      ").  Privacy on the Website is of great importance to us.  Because we may gather some important information from our users, visitors, subscribers, and customers (collectively "
                    ),
                    _c("a", [_vm._v("“Subscribers”")]),
                    _vm._v(" or "),
                    _c("a", [_vm._v("“you”")]),
                    _vm._v(" or "),
                    _c("a", [_vm._v("“your”")]),
                    _vm._v(
                      "), we have established this Privacy Policy as a means to communicate our information gathering and dissemination practices.  By accessing the Website, you acknowledge and agree to this Privacy Policy and also agree to application Terms of Use, which can be accessed and reviewed at \n                    "
                    ),
                    _vm._v(" "),
                    _c("router-link", { attrs: { to: { name: "Terms" } } }, [
                      _vm._v(" https://www.velocityvehiclegroup.com/terms ")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("strong", [_vm._v("PERSONAL INFORMATION WE COLLECT")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "When you visit the Website, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the Website, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site. We refer to this automatically-collected information as “Device Information.”"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "We collect Device Information using the following technologies:"
                  )
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "- “Log files” track actions occurring on the Site, and collect data including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "- “Web beacons,” “tags,” and “pixels” are electronic files used to record information about how you browse the Site."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "We use the Google Analytics to help us run our website and business.  We are not liable for how these companies collect and store data. "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Additionally when you make a purchase or attempt to make a purchase through the website, we collect certain information from you, including your name, billing address, shipping address, payment information (including credit card numbers, billing account numbers, email address, and phone number).  We refer to this information as “Order Information.”"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "If you choose to share your email address with us, you agree to receive marketing emails from our various departments within VVG. You will have an opportunity to unsubscribe to any emails or mailings by clicking on an “unsubscribe” hyperlink contained in promotional emails we send you. We do not share or sell your email or contact information with anyone outside of the VVG network."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "When we talk about “Personal Information” in this Privacy Policy, we are talking both about Device Information and Order Information."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [
                  _vm._v("HOW DO WE USE YOUR PERSONAL INFORMATION?")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "We use the Order Information that we collect generally to fulfill any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations).  If you provide credit card or other authorized payment method information to VELOCITY, you authorize VELOCITY, or a credit card processor of its choosing to receive appropriate billing information, then bill such credit card or to make such charges as applicable. Additionally, we use this Order Information to:"
                  )
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("Communicate with you;")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Screen our orders for potential risk or fraud; and")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "When in line with the preferences you have shared with us, provide you with information or advertising relating to our products or services."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "If you place an order through our website, we only store that information for processing and managing your order."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address), and more generally to improve and optimize our Site (for example, by generating analytics about how our customers browse and interact with the Site, and to assess the success of our marketing and advertising campaigns)."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v("SHARING YOUR PERSONAL INFORMATION")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "We share your Personal Information with third parties to help us use your Personal Information, as described above.  We use a variety of third party applications, including social media tools, Google Analytics, and payment processing companies to handle some features."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [
                  _vm._v("REVIEWING AND UPDATING YOUR INFORMATION")
                ]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("strong", [_vm._v("MARKETING")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "We deliver marketing and event communications to you across various platforms such as email, telephone, text messaging, direct mail and online. Where required by law, we will ask you to explicitly opt in to receive marketing from us. (such as subscribing to our newsletter via our websites). If we send you a marketing communication it will include instructions on how to opt out of receiving these communications in the future. "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Honoring your marketing preferences is important to us. You have the right to opt out of receiving direct marketing and targeted online advertising."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v("BEHAVIORAL ADVERTISING")]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c("p", [
                  _vm._v("You can opt out of targeted advertising by:")
                ]),
                _vm._v(" "),
                _vm._m(4),
                _vm._m(5),
                _vm._m(6),
                _vm._m(7),
                _vm._v(" "),
                _c("strong", [_vm._v("Third Party Websites")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "The Website may contain links to other websites.  We are not responsible for the privacy practices or the content of these other websites.  You will need to check the policy statement of these others websites to understand their policies.  When you access a linked site you may be disclosing private information. It is your responsibility to keep such information private and confidential."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v("Security")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Please note that data that is transported over an open network, such as the Internet or e-mail, may be accessible to anybody. We cannot guarantee the confidentiality of any communication or material transmitted via such open networks. When disclosing any personal information via an open network, you should remain mindful of the fact that it is potentially accessible to others, and consequently, can be collected and used by others without your consent. In particular, while individual data packets are often encrypted, the names of the sender and recipient are not. A third party may therefore be able to trace an existing bank account or relationship or one that is subsequently created. Even if both the sender and recipient are located in the same country data may also be transmitted via such networks to other countries regularly and without controls, including to countries that do not afford the same level of data protection as your country of domicile."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Your data may be lost during transmission or may be accessed by unauthorized parties. We do not accept any liability for direct or indirect losses as regards the security of your Personal Information or data during its transfer via Internet. Please use other means of communication if you think this is necessary or prudent for security reasons."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v("DO NOT TRACK")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v("YOUR RIGHTS")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "If you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Additionally, if you are a European resident we note that we are processing your information in order to fulfill contracts we might have with you (for example if you make an order through the Site), or otherwise to pursue our legitimate business interests listed above.  Additionally, please note that your information will be transferred outside of Europe, including to Canada and the United States."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v("DATA RETENTION")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "When you place an order through the Site, we will maintain your Order Information for our records unless and until you ask us to delete this information. We may delete or archive your data after a certain time period has passed."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v("MINORS")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "VELOCITY does not wish to collect any Personal Information (or any information at all) from any persons under 14 years old.  If you are under 14 years old, you may not use the Website"
                  )
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v("Updates to our Privacy Policy")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "If we make any material changes to this Privacy Policy, we will post a notice on this Website notifying users of the changes. In some cases, we also may send an email notifying users of the changes. You should check this Website periodically to see if any recent changes to this Privacy Policy have occurred."
                  )
                ]),
                _vm._v(" "),
                _vm._m(8),
                _vm._v(" "),
                _c("strong", [_vm._v("Additional Information")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "This Policy is part of the Terms of Use of the Website and any use of the Website is governed by those Terms of Use."
                  )
                ]),
                _vm._v(" "),
                _c("strong", [_vm._v("CONTACT US")]),
                _vm._v(" "),
                _vm._m(9),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "2429 S. Peck Road, Whittier, CA, 90601, United States"
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-block" }, [
      _c("b", [
        _vm._v(
          "Velocity Vehicle Group Privacy Policy for https://www.velocityvehiclegroup.com/"
        )
      ]),
      _vm._v(
        " nd all other Velocity Vehicle Group division websites.\n                    "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "- “Cookies” are data files that are placed on your device or computer and often include an anonymous unique identifier. For more information about cookies, and how to disable cookies, visit "
      ),
      _c("a", { attrs: { href: "https://www.allaboutcookies.org" } }, [
        _vm._v("https://www.allaboutcookies.org")
      ]),
      _vm._v(".")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "If you register for an account on the Website, you may review and update your account information by logging in to your account with your username and password at "
      ),
      _c("a", { attrs: { href: "https://www.velocityvehiclegroup.com" } }, [
        _vm._v("https://www.velocityvehiclegroup.com")
      ]),
      _vm._v(" as well as through additional links throughout the Website.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "As described above, we use your Personal Information to provide you with targeted advertisements or marketing communications we believe may be of interest to you.  For more information about how targeted advertising works, you can visit the Network Advertising Initiative’s (“NAI”) educational page at "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://www.networkadvertising.org/understanding-online-advertising/how-does-it-work"
          }
        },
        [
          _vm._v(
            "https://www.networkadvertising.org/understanding-online-advertising/how-does-it-work."
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("FACEBOOK - "),
      _c(
        "a",
        { attrs: { href: "https://www.facebook.com/settings/?tab=ads" } },
        [_vm._v("https://www.facebook.com/settings/?tab=ads")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("GOOGLE - "),
      _c(
        "a",
        { attrs: { href: "https://www.google.com/settings/ads/anonymous" } },
        [_vm._v("https://www.google.com/settings/ads/anonymous")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("BING - "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads"
          }
        },
        [
          _vm._v(
            "https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads"
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Additionally, you can opt out of some of these services by visiting the Digital Advertising Alliance’s opt-out portal at: "
      ),
      _c("a", { attrs: { href: "https://optout.aboutads.info/" } }, [
        _vm._v("https://optout.aboutads.info/.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "If you have any questions regarding this Privacy Policy, you should contact our Customer Service Department. "
      ),
      _c(
        "a",
        { attrs: { href: "https://www.velocityvehiclegroup.com/contact-us" } },
        [_vm._v("https://www.velocityvehiclegroup.com/contact-us")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at "
      ),
      _c("a", { attrs: { href: "mailto:smannshahia@vvgtruck.com" } }, [
        _vm._v("smannshahia@vvgtruck.com")
      ]),
      _vm._v(" or by mail using the details provided below:")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ea65294", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea65294","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/PrivacyPolicy.vue
// module id = null
// module chunks = 